import cn from 'classnames';
import styles from './shadowBox.module.scss';

export interface ShadowBoxProps {
    targetClass?: string;
    children: React.ReactNode;
    animateOnHoverMobile?: boolean;
    animateOnHoverDesktop?: boolean;
}

export function ShadowBox({
    targetClass = '',
    children,
    animateOnHoverMobile = false,
    animateOnHoverDesktop = false,
}: ShadowBoxProps) {
    const classNames = cn(styles.shadowBox, targetClass, {
        [styles.animateOnHoverMobile]: animateOnHoverMobile,
        [styles.animateOnHoverDesktop]: animateOnHoverDesktop,
    });

    return <div className={classNames}>{children}</div>;
}
